import React, { useState, useContext, useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { ProgressBar } from "react-bootstrap";

// import ConvertAPI from 'convertapi';
import { fileToPng } from "./file-to-image";
import dayjs from "dayjs";

import {
  PresentationVersion,
  Version,
  VersionList,
} from "../../src/types/presentation";

import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useIntl, FormattedMessage } from "react-intl";

import UserContext from "../contexts/user";
import EventContext from "../contexts/event";

import { EventData, Presentation } from "../types/presentation";
import EditProfileModal from "../components/edit-profile-modal";
import LocaleSwitcher from "../components/locale-switcher";
import NewVideoItem from "./new-video-item";
import SidebarNewVideo from "../components/sidebar-new-video";
import ReactPlayer from "react-player";
import axios from "axios";
import useAxios from "axios-hooks";
import { useParams } from "react-router-dom";
import UploadPresentation from "./upload-pres";
import VideoModal from "../components/video-modal";
import "./preloader.scss";
import getUuid from "uuid-by-string";
import AlertModal from "../components/alert-modal";
import deleteS3Object from "../helpers/deleteS3Object";
import ValidationModel from "../components/validation-model";


const _ = require("lodash");

// import Alert from "react-s-alert";

const useViewport = () => {
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  return { width };
};

const NewSchedule: React.FC<{
  isSpeaker: boolean;
  eventData: EventData;
  locale: string;
  presentation_id: string;
  setLocale: (arg0: string) => void;
  // presentation:Presentation
}> = ({ eventData, locale, setLocale, isSpeaker, presentation_id }) => {
  const intl = useIntl();
  const location = useLocation();
  const userContext = useContext(UserContext);
  const eventContext = useContext(EventContext);
  const [isVirtual] = useState(
    queryString.parse(location.search).viewmode === "virtual"
  );
  const [isIframe] = useState(queryString.parse(location.search).iframe);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [uploadTab, setUploadTab] = useState("");
  const [rightVideo, setRightVideo] = useState("");
  const [leftVideo, setLeftVideo] = useState("");
  const [LeftVideo, sLeftVideo] = useState("");
  const [RightVideo, sRightVideo] = useState("");
  const [file, setFile] = useState("");
  const [ppt, setPpt] = useState("");
  const [pdf, setPdf] = useState("");
  const fileType = file.split(".").pop();

  // const [data, setData] = useState([]);
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);
  const [Loading, setloading] = useState("");
  const [completed, setcompleted] = useState(false);


  const [versions, setVersions] = useState<Version[]>([]);
  // check versions has data
  if (versions && versions.length) {
    // sort versions based
    versions.sort(function (a, b) {
      var dateA: any = new Date(a.date),
        dateB: any = new Date(b.date);
      return dateB - dateA;
    });
  }
  const [versionList, setVersionList] = useState<Version[]>([]);
  const [singlePresentation, setSinglePresentation] =
    useState<PresentationVersion>();

  const [showVideoModal, setsShowVideoModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [pptmessage, setPptMessage] = useState("");
  const [activeVideo, setActiveVideo] = useState({
    security_token: "",
    id: "",
  });
  const [progress, setProgress] = useState(0);

  const [uploadDocument, setUploadDocument] = useState("");

  const [open, setOpen] = useState(false);
  const [activity, setActivity] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [securityToken, setSecurityToken] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [fileName, setFileName] = useState("");
  const [processCount, setProcessCount] = useState(0);

  const [videoPagewidth, setVideoPageWidth] = useState(() => {
    // based on page width find mobile and desktop view
    if (window.innerWidth <= 575) {
      return true;
    } else {
      return false;
    }
  });

  //
  const { width } = useViewport();
  const breakpoint = 620;

  // toggle to show/hide  AlertValidationModal
  const handleAlertValidationModal = () => {
    setShowValidationModal(!showValidationModal);
  };

  // filter state values
  const [filter, setFilter] = useState<{
    presentations: Array<string>;
    speakers: Array<string>;
    rooms: Array<string>;
    associations: Array<string>;
    dates: Array<string>;
    activeQuizzesOnly: boolean;
  }>({
    presentations: [],
    speakers: [],
    rooms: [],
    associations: [],
    dates: [],
    activeQuizzesOnly: false,
  });

  const [url, setUrl] = useState("");
  const [duration, setDuration] = useState("");

  // toggle video alert model view
  const handleVideoClose = () => {
    setsShowVideoModal(!showVideoModal);
  };

  // toggle normal alert model view
  const handleAlertModal = () => {
    setShowAlertModal(!showAlertModal)
  };

  let previousDate: string | null = null;
  const days = eventData.aggregates.dates.sort((a: string, b: string) =>
    a.localeCompare(b)
  );
  //get event slung from url
  const slug = document.location.pathname.split("/")[1] || "invalid";
  //get event presentation id from url
  const p_id = document.location.pathname.split("/")[3] || "invalid";

  let versionPpt = eventData.presentations.filter((ppt) => ppt._id === p_id);

  const p = [1];
  //  state hold values to offline / online list of boolean
  const [checkedState, setCheckedState] = useState(
    new Array(p.length).fill(false)
  );
  //  state hold checked values to online, list of boolean
  const [checkedStatus, setCheckedStatus] = useState(
    new Array(p.length).fill(false)
  );
  const check = checkedStatus.includes(true);

  const params = useParams();

  // token value from cache for api calls
  let token: any = localStorage.getItem(`token-${slug}`);
  let ws: any = null;
  useEffect(() => {

    // if  ws null then initialize web socket
    if (ws == null) {

      // initialize web socket object
      ws = new WebSocket(
          `${process.env.REACT_APP_INTERFACE_SOCKET_URL}?event_id=${eventData.event._id}&presentation_id=${presentation_id}`
      );
    }
  }, []);

  useEffect(()=>{
    setTimeout(()=>{
      // call updated data form backend
      onDataChangeCallback();
    },4000)

  },[])

  useEffect(() => {
    // API for getting information regarding presentation and its versions
    axios
      .get<VersionList>(
        `
        ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/presentation/${p_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        // set presentation data
        setSinglePresentation(response.data.data);
        // set version list data
        setVersionList(response.data.data.versions);
        // set versions in state
        setVersions(response.data.data.versions);
        console.log("versions testing in new schedule page",versions);
        
        const presentation_version: Version[] = response.data.data.versions;
        checkedState.length = presentation_version.length;
        // set state of boolean based in versions list
        checkedState.fill(false);
        checkedStatus.length = presentation_version.length;
        // set state of boolean based in versions list
        checkedStatus.fill(false);
      })
      .catch((error) => {
         console.log(error);
      });
  }, []);


  const headers = {
    Accept: "application/json",
    "Content-Type": "appl  ication/json",
    Authorization: token,
  };

  const querryParams = {
    presentation_id: p_id,
    event_id: eventContext.id,
    speaker_id: userContext.user?.speaker_id,
  };

  // **
  // * Function to get versions from backend
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param  jwt token
  // * @return  sprout video upload token
  // */

  function onDataChangeCallback(){

    //  get versions data from presentation table
    axios
        .get<VersionList>(
            `
        ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/presentation/${p_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        )
        .then((response) => {
          console.log('Returned page', response);
          setSinglePresentation(response.data.data);
          setVersionList(response.data.data.versions);
          setVersions(response.data.data.versions);
          const presentation_version: Version[] = response.data.data.versions;
          checkedState.length = presentation_version.length;
          checkedState.fill(false);
          checkedStatus.length = presentation_version.length;
          checkedStatus.fill(false);
        })
        .catch((error) => {
          console.log(error);
        });

  }

  // APi call for getting video token from dynamoDB
  const [{ loading: getVideoTokenLoading }, getVideoToken] = useAxios(
    {
      url: `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-token/${p_id}`,
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    {
      manual: true,
    }
  );

  // **
  // * Function to upload  video
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param
  // * @return  video id and security token
  // */
  const [{ data, loading, error }, uploadVideo] = useAxios({
    url: "https://api.sproutvideo.com/v1/videos", //

    method: "POST",
    data: {
      download_hd: true,
    },
  });

  // **
  // * Function to update online/offline status into backend
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param
  // * @return
  // */
  const updateOnlineValue = (
    versionId: string,
    online: boolean,
    idx: number
  ) => {

    // set versions state
    setVersions((versions) => {
      // call set method to get the value
      var newVersions: any = [];

      versions.length &&
        versions.map(function (version) {
          if (version.versionId == versionId) {
            newVersions.push({
              ...version,
              online: online,
            });
          } else {
            newVersions.push(version);
            // return version
          }
        });

      return newVersions;
    });
     console.log("online-status start", versions);
    axios
      .patch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${p_id}/version/${versionId}/online-status`,
        {
          online: online,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
         console.log("online-status", versions);
        setVersions((versions) => {
          // call set method to get the value
           console.log("inside set versions", versions);
          var newVersions: any = [];

          versions.length &&
            versions.map(function (version) {
              if (version.versionId == versionId) {
                newVersions.push({
                  ...version,
                  online: online,
                });

              } else {
                newVersions.push(version);
                // return version
              }
            });

          return newVersions;
        });
        // get version from state
        const presentation_version: Version[] = response.data.versions;
        // check item is online
        if (online) {
          setAlertType("wait");
          setPptMessage(
            "You Version Is Online"
          );
          setShowAlertModal(true);
        } else {
          // update checkedState list al all data to false for make version item online
          checkedState.length = presentation_version.length;
          checkedState.fill(false);
          setAlertType("wait");
          setPptMessage(
            "You Version Is Offline"
            // "Chaptering is going on , please wait a moment"
          );
          setShowAlertModal(true);
        }
      })
      .catch((error) => {
         console.log(error);
      });
  };

  // function to video upload
  const videoUpload = async (event: any, videoType: string) => {
    setLeftVideo(URL.createObjectURL(event.target.files[0]));

    const file = event.target.files[0];


    try {
      // get video token for api formdata
      const lefttokenResponse = await getVideoToken();
      // upload token
      const leftuploadToken = lefttokenResponse.data;
      // form data object
      var leftformData = new FormData();
      leftformData.append("source_video", file);
      leftformData.append("token", leftuploadToken);
      // api call with form data for upload video
      const leftvideoUpload = await uploadVideo({
        data: leftformData,
      });
    } catch (error) {
       console.log(error);
    }
  };

  // **
  // * Function to send   presentation video and webcam video details to addToStack table in mongodb in interface project
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param
  // * @return  chaptering video via AI algorithm
  // */
  const eslideAddToStack = async (option: string, ...params: any) => {
    // option one add stack handle block
    if (option == "first") {

      // API call for add to back stack API
      axios
        .post(`${process.env.REACT_APP_INTERFACE_URL}/add-to-stack`, {
          pdfUrl: params[0],
          pptUrl: params[1],
          video: {
            id: params[2],
            security_token: params[3],
          },
          webcam: {
            id: params[4],
            security_token: params[5],
          },
          presentationId: p_id,
          eventId: eventContext.id,
          option: uploadTab,
          versionId: params[6],
        })
        .then((responseData) => {
          // set values in state from api success
          setAlertType("wait");
          setPptMessage("Chaptering is processing");
          setShowAlertModal(true);

          setUploadTab("");
          setDisableSaveBtn(false);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");
          // timer callback for update UI
          setTimeout(() => {
            setShowAlertModal(false);
          }, 5000);
        })
        .catch((error) => {
          // set values in state from api failure
          setAlertType("Error");
          setPptMessage("Something Went Wrong");
          setShowAlertModal(true);
          setUploadTab("");
          // setIsLoading(false);
          setDisableSaveBtn(false);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 10000);
        });
    }
    if (option == "two" || option == "three") {
      // API call for add to back stack API
      await axios
        .post(`${process.env.REACT_APP_INTERFACE_URL}/add-to-stack`, {
          presentationId: p_id,
          eventId: eventContext.id,
          pdfUrl: params[0],
          pptUrl: params[1],
          video: {
            id: params[2],
            security_token: params[3],
          },

          option: uploadTab,
          versionId: params[4],
        })
        .then((response) => {
          // set values in state from api success
          setAlertType("Success");
          setPptMessage("Chaptering is processing");
          setShowAlertModal(true);
          setDisableSaveBtn(false);
          setUploadTab("");
          // setIsLoading(false);

          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 5000);
        })
        .catch((error) => {
          // set values in state from api failure
          setAlertType("Error");
          setPptMessage("Something Went Wrong");
          setShowAlertModal(true);
          setUploadTab("");
          // setIsLoading(false);
          setDisableSaveBtn(false);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 10000);
        });
    }
  };

  // **
  // * Function to upload  presentation video and webcam video
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param
  // * @return  upload video in sprout and save video and presentation details in database
  // */
  const uploadCall = async () => {
    let uploadPptFile = "";
    let uploadPdfFile = "";
    // check selecetd file type
    if (fileType === "pptx" || fileType === "ppt") {
      uploadPptFile = file;
    } else {
      uploadPdfFile = file;
    }
    // model and message state change
    setDisableSaveBtn(true);
    setAlertType("Progress");
    setPptMessage(intl.formatMessage({ id: 'uploading.webcam.message' }));
    setShowAlertModal(true);

    // video file data
    const pptfile = file;
    const leftfile = LeftVideo;
    const rightfile = RightVideo;


    try {

      // get video upload token for leftvideo
      const lefttokenResponse = await getVideoToken();
      const leftuploadToken = lefttokenResponse.data;

      //get video upload token for rightvideo
      const righttokenResponse = await getVideoToken();
      const rightuploadToken = righttokenResponse.data;

      // cam video form data
      var leftformData = new FormData();
      leftformData.append("source_video", leftfile);
      leftformData.append("token", leftuploadToken);

      // presentation video form data
      var rightformData = new FormData();
      rightformData.append("source_video", rightfile);
      rightformData.append("token", rightuploadToken);

      // upload cam video to sprout video
      const leftvideoUpload = await uploadVideo({
        data: leftformData,
        onUploadProgress : progressEvent => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log("onUploadProgress 1",percentCompleted);
           setProcessCount(percentCompleted);
        }
      });
      setPptMessage(intl.formatMessage({ id: 'uploading.presentation.message' }));
      // upload presentation video to sprout video
      const RightvideoUpload = await uploadVideo({
        data: rightformData,
        onUploadProgress : progressEvent => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log("onUploadProgress 2",percentCompleted);
          setProcessCount(percentCompleted);
        }
      });

      let versionIdByDateTime = getUuid(dayjs().unix().toString());
      // add version api call in presentation table DynamoDB
      await axios
        .patch(
          `
        ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${p_id}/versions `,

          {
            fileName: fileName,
            pdfUrl: uploadPdfFile,
            pptUrl: uploadPptFile,

            video: {
              id: leftvideoUpload.data.id,
              security_token: leftvideoUpload.data.security_token,
            },
            webcam: {
              id: RightvideoUpload.data.id,
              security_token: RightvideoUpload.data.security_token,
            },
            option: uploadTab,
            versionId: versionIdByDateTime,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
         // add version success block for update UI state
          setVersions(response.data.versions);
          const presentation_version: Version[] = response.data.versions;
          checkedState.length = presentation_version.length;
          checkedState.fill(false);
          checkedStatus.length = presentation_version.length;
          checkedStatus.fill(false);


          // API to add version in stack table ,AI interface call
          axios
            .post(`${process.env.REACT_APP_INTERFACE_URL}/add-to-stack`, {
              pdfUrl: uploadPdfFile,
              pptUrl: uploadPptFile,
              video: {
                id: RightvideoUpload.data.id,
                security_token: RightvideoUpload.data.security_token,
              },
              webcam: {
                id: leftvideoUpload.data.id,
                security_token: leftvideoUpload.data.security_token,
              },
              presentationId: p_id,
              eventId: eventContext.id,
              option: uploadTab,
              versionId: versionIdByDateTime,
            })
            .then((responseData) => {
              // Add to stack API success catch block for UI state change
              setAlertType("wait");
              setPptMessage("Chaptering is processing");
              setShowAlertModal(true);

              setUploadTab("");
              setDisableSaveBtn(false);
              setLeftVideo("");
              setRightVideo("");
              setUploadDocument("");

              setTimeout(() => {
                setShowAlertModal(false);
              }, 5000);
            })
            .catch((error) => {
              // Add to stack API exception catch block for UI state change
              setAlertType("Error");
              setPptMessage("Something Went Wrong");
              setShowAlertModal(true);
              setUploadTab("");
              // setIsLoading(false);
              setDisableSaveBtn(false);
              setLeftVideo("");
              setRightVideo("");
              setUploadDocument("");

              setTimeout(() => {
                setShowAlertModal(false);
              }, 10000);
            });
          // }
        })
        .catch((error) => {
          // add version failure block for update UI state
          setAlertType("Error");
          setPptMessage("Something Went Wrong");
          setShowAlertModal(true);
          setUploadTab("");
          // setIsLoading(false);
          setDisableSaveBtn(false);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 10000);
        });
    } catch (error) {
      // add version exception  block for update UI state
      setAlertType("Error");
      setPptMessage("Something Went Wrong");
      setShowAlertModal(true);
      setUploadTab("");
      // setIsLoading(false);
      setDisableSaveBtn(false);
      setLeftVideo("");
      setRightVideo("");
      setUploadDocument("");

      setTimeout(() => {
        setShowAlertModal(false);
      }, 10000);
    }
  };

  // **
  // * Function to upload  presentation video and
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param
  // * @return  upload video in sprout and save video and presentation details in database
  // */

  const uploadSectioTwo = async () => {
    // convert file to pdf function call
    fileToPng(file);

    let uploadPptFile = "";
    let uploadPdfFile = "";
    // check file type for upload
    if (fileType === "pptx" || fileType === "ppt") {
      uploadPptFile = file;
    } else {
      uploadPdfFile = file;
    }
    // update state for models and messages
    setDisableSaveBtn(true);
    setAlertType("Progress");
    setPptMessage(intl.formatMessage({ id: 'uploading.presentation.message' }));
    setShowAlertModal(true);

    const pptfile = file;
    const leftfile = LeftVideo;


    try {
      // get video upload token for presentation video
      const lefttokenResponse = await getVideoToken();
      const leftuploadToken = lefttokenResponse.data;

      // upload form data
      var leftformData = new FormData();
      leftformData.append("source_video", leftfile);
      leftformData.append("token", leftuploadToken);

      // upload data to sprout video
      const leftvideoUpload = await uploadVideo({
        data: leftformData,
        onUploadProgress : progressEvent => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log("percentCompleted 1",percentCompleted);
          setProcessCount(percentCompleted);
        }
      });
      // generate the  uuid for new version
      let versionIdByDateTime = getUuid(dayjs().unix().toString());
      // add version api call for dynamo db
      await axios
        .patch(
          `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${p_id}/versions`,
          {
            pdfUrl: uploadPdfFile,
            fileName: fileName,
            pptUrl: uploadPptFile,
            video: {
              id: leftvideoUpload.data.id,
              security_token: leftvideoUpload.data.security_token,
            },
            option: uploadTab,
            versionId: versionIdByDateTime,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress : progressEvent => {
              var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              console.log("percentCompleted",percentCompleted);
            }
          }
        )
        .then((response) => {
          // API success block for update the UI state
          setProcessCount(0);
          setVersions(response.data.versions);
          const presentation_version: Version[] = response.data.versions;
          checkedState.length = presentation_version.length;
          checkedState.fill(false);
          checkedStatus.length = presentation_version.length;
          checkedStatus.fill(false);
        })
        .catch((error) => {
          // API failure block for update the UI state
          setAlertType("Error");
          setPptMessage("Something Went Wrong");
          setShowAlertModal(true);
          setUploadTab("");
          // setIsLoading(false);
          setDisableSaveBtn(false);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 10000);
        });

      // API to add version in stack table ,AI interface call
      await axios
        .post(`${process.env.REACT_APP_INTERFACE_URL}/add-to-stack`, {
          presentationId: p_id,
          eventId: eventContext.id,
          pdfUrl: uploadPdfFile,
          pptUrl: uploadPptFile,
          video: {
            id: leftvideoUpload.data.id,
            security_token: leftvideoUpload.data.security_token,
          },

          option: uploadTab,
          versionId: versionIdByDateTime,
        })
        .then((response) => {
          // Add to stack API success block for UI state change
          setAlertType("Success");
          setPptMessage("Chaptering is processing");
          setShowAlertModal(true);
          setDisableSaveBtn(false);
          setUploadTab("");
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 5000);
        })
        .catch((error) => {
          // Add to stack API failure block for UI state change
          setAlertType("Error");
          setPptMessage("Something Went Wrong");
          setShowAlertModal(true);
          setUploadTab("");
          // setIsLoading(false);
          setDisableSaveBtn(false);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");

          setTimeout(() => {
            setShowAlertModal(false);
          }, 10000);
        });
    } catch (error) {
      // Add to stack API exception catch block for UI state change
      setAlertType("Error");
      setPptMessage("Something Went Wrong");
      setShowAlertModal(true);
      setUploadTab("");
      // setIsLoading(false);
      setDisableSaveBtn(false);
      setLeftVideo("");
      setRightVideo("");
      setUploadDocument("");

      setTimeout(() => {
        setShowAlertModal(false);
      }, 10000);
    }
  };

  // **
  // * Function to upload presentation video and cam video for AI processing
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param
  // * @return  upload video in sprout and save video and presentation details in database
  // */

  const uploadSectionFour = async () => {
    let uploadPptFile = "";
    let uploadPdfFile = "";
    // check file type of selected file
    if (fileType === "pptx" || fileType === "ppt") {
      uploadPptFile = file;
    } else {
      uploadPdfFile = file;
    }
    // update state for messages and models
    setDisableSaveBtn(true);
    setAlertType("Loading");
    setPptMessage(intl.formatMessage({ id: 'uploading.presentation.message' }));
    setShowAlertModal(true);
    // API for add version in presenatation table in dynamodb
    await axios
      .patch(
        `
    ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${p_id}/versions `,
        {
          pdfUrl: uploadPdfFile,
          pptUrl: uploadPptFile,

          option: uploadTab,
          versionId: getUuid(dayjs().unix().toString()),
          fileName,
          // status:"success"
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        //  update UI state from success of the API call
        setAlertType("Success");
        setPptMessage("Presentation  Uploaded");
        setShowAlertModal(true);
        setDisableSaveBtn(false);
        setUploadTab("");

        setLeftVideo("");
        setRightVideo("");
        setUploadDocument("");
        setVersions(response.data.versions);
        const presentation_version: Version[] = response.data.versions;
        checkedState.length = presentation_version.length;
        checkedState.fill(false);
        checkedStatus.length = presentation_version.length;
        checkedStatus.fill(false);

        setTimeout(() => {
          setShowAlertModal(false);
        }, 5000);

        //
      })
      .catch((error) => {
        //  update UI state from Failure of the API call
        setAlertType("Error");
        setPptMessage("Something Went Wrong");
        setShowAlertModal(true);
        setUploadTab("");
        // setIsLoading(false);
        setDisableSaveBtn(false);
        setLeftVideo("");
        setRightVideo("");
        setUploadDocument("");

        setTimeout(() => {
          setShowAlertModal(false);
        }, 10000);
      });

  };

  // **
  // * Function to delete version
  // * Note: use only for first time
  // * @author   Narayan kumar jha
  // * @param    presentation id(p_id) and version id
  // * @return  delete version details from database
  // */
  const deleteVersionById = async (version_Id: any) => {
    // delete version from presentation table
    await axios
      .delete<Presentation>(
        `
    ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${p_id}/version/${version_Id}`,

        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      )
      .then((response) => {
        // update the state after api success
        setVersions(response.data.versions);
        const presentation_version: Version[] = response.data.versions;
        checkedState.length = presentation_version.length
          ? presentation_version.length
          : checkedState.length;
        checkedState.fill(false);
        checkedStatus.length = presentation_version.length
          ? presentation_version.length
          : checkedStatus.length;
        checkedStatus.fill(false);
        setAlertType("Success");
        setPptMessage("Version deleted succesfully");
        setShowAlertModal(true);

        // delete version from AI interface stack table table
        axios
          .delete(
            `
      ${process.env.REACT_APP_INTERFACE_URL}/version/${version_Id} `
          )
          .then((responseData) => {})
          .catch((error) => {
          });
      });
  };

  const [currentIdx, setCurrentIdx] = useState(-1);

  //  console.log("userContextuser", userContext);

  useEffect(() => {
    // ws.current = new WebSocket(` ${process.env.REACT_APP_INTERFACE_SOCKET_URL}`);
    ws.onopen = () =>  console.log("ws opened");
    ws.onclose = () =>  console.log("ws closed");

    // const wsCurrent = ws.current;

    return () => {
      ws.close();
    };
  }, []);

  useEffect(() => {
     console.log("versions.length", versions);
     console.log("versions.length 1", versions.length);
    if (!ws) return;
    // socket on message callback
    ws.onmessage = (e: any) => {
      if (e.data !== "empty") { // check data is empty or mot
        const versionItem = JSON.parse(e.data);

        //  if (versions && versions.length && versionItem) {

        // set versions state
        setVersions((versions) => {

          var newVersions: any = [];
          versions.length &&

            versions.map(function (version) {
              if (
                version.versionId.toString() ==
                (versionItem?.versionId).toString()
              ) // get changed version item from versions list
              {
                // update changes in versions list
                newVersions.push({
                  ...version,
                  percent: versionItem.percent,
                  status: versionItem.status,
                });
                // block handle chaptering complete state
                if (versionItem.percent == 100) {
                  setAlertType("wait");
                  setPptMessage("The video with chapters is ready");
                  setShowAlertModal(true);
                }
                if (
                  versionItem.status == "success" ||
                  versionItem.status == "failed" || versionItem.status == "PPT to PDF file convert failed"
                ) // check version item status for socket update
                {
                  ws.send(versionItem.versionId); // send socket message
                }
              } else {
                newVersions.push(version); // push version item to version list
                // return version
              }
            });

          return newVersions;
        });
      }
    };
  }, [ws]);


  return (
    <div className="home-container-with-login">
      <div
        className={`grid-contianer ${isIframe ? "iframe-mode-container" : ""}`}
      >
        <LocaleSwitcher locale={locale} setLocale={setLocale} />
        <div className="sidebar">
          <SidebarNewVideo
            event={eventData.event}
            aggregates={eventData.aggregates}
            filter={filter}
            roomId={singlePresentation?.room_id}
            setFilter={setFilter}
            openProfileModal={openProfileModal}
            setOpenProfileModal={setOpenProfileModal}
            presentationName={singlePresentation?.name}
            PresentationDate={singlePresentation?.date}
            PresentationId={singlePresentation?._id}
            filters={false}
          />
        </div>
        <div className="main new-video-main p-t-50">
          <Container>
            {isIframe && (
              <Row className="top-menu-container m-b-20">
                <Col md={4}></Col>
                <Col>
                  <div className="top-menu pad-0 top-menu-mob">
                    <Button
                      className={`nav-link ${
                        filter.activeQuizzesOnly ? "" : "active"
                      }`}
                      onClick={() =>
                        setFilter({ ...filter, activeQuizzesOnly: false })
                      }
                    >
                      <img src="/icons/schedule-ico.svg" alt="schedule" />
                      <span className="text">
                        <FormattedMessage id="menu.schedule" />
                      </span>
                    </Button>
                    <Button
                      className="nav-link d-none d-lg-block"
                      onClick={() => alert("work in progress")}
                    >
                      <img src="/icons/synopsis-ico.svg" alt="Synopsis" />
                      <span className="text">
                        <FormattedMessage id="menu.synopsis" />
                      </span>
                    </Button>
                    {userContext.user && (
                      <>
                        <Button
                          className="nav-link"
                          onClick={() => setOpenProfileModal(!openProfileModal)}
                        >
                          <img src="/icons/profile-ico.svg" alt="PROFILE" />
                          <span className="text">
                            <FormattedMessage id="menu.profile" />
                          </span>
                        </Button>
                        <Button
                          className="nav-link"
                          onClick={() => {
                            userContext.setListUser(
                              JSON.stringify({ id: "", token: "" })
                            );
                          }}
                          to="#"
                        >
                          <img src="/icons/profile-ico.svg" alt="PROFILE" />
                          <span className="profile-tick"></span>
                          <span className="text">
                            <FormattedMessage id="menu.logout" />
                          </span>
                        </Button>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            <Row className="new-schedule">
              <Col className="schedule-main-contianer">
                <span className="title"> {intl.formatMessage({ id: 'upload.version' })} </span>
                {/* sm={8} md={8} */}

                <Col lg={9} className="schedule-main-container-mo">
                  <div className="header">
                    <div className=" row">
                      <Col
                        sm={3}
                        md={3}
                        lg={3}
                        className="item responsive-item"
                      >
                        {/* className="sub-title" */}
                        <span className="sub-title">Upload</span>
                        <span className="sub-title-mo">new version:</span>
                      </Col>
                      <Col
                        sm={3}
                        md={3}
                        lg={3}
                        className={
                          uploadTab
                            ? uploadTab == "first"
                              ? "item active"
                              : "item inactive"
                            : "item active"
                        }
                        onClick={function () {
                          if (uploadTab == "first") {
                            setUploadTab("");
                          } else {
                            setUploadTab("first");
                          }
                        }}
                      >
                        <img
                          className="small"
                          src="/icons/first.svg"
                          alt="file only"
                        />

                        <span className="sub-title">
                          {intl.formatMessage({ id: 'webcam.and.presentation' })}
                        </span>
                      </Col>
                      <Col
                        sm={3}
                        md={3}
                        lg={3}
                        className={
                          uploadTab
                            ? uploadTab == "two"
                              ? "item active"
                              : "item inactive"
                            : "item active"
                        }
                        onClick={function () {
                          if (uploadTab == "two") {
                            setUploadTab("");
                          } else {
                            setUploadTab("two");
                          }
                          // setUploadTab("two");

                          setLeftVideo("");
                          setRightVideo("");
                          setUploadDocument("");
                        }}
                      >
                        <img
                          className="small"
                          src="/icons/two.svg"
                          alt="file only"
                        />

                        <span className="sub-title"> {intl.formatMessage({ id: 'presentation.video' })}</span>
                      </Col>
                      <Col
                        sm={3}
                        md={3}
                        lg={3}
                        className={
                          uploadTab
                            ? uploadTab == "three"
                              ? "item active"
                              : "item inactive"
                            : "item active"
                        }
                        onClick={function () {
                          if (uploadTab == "three") {
                            setUploadTab("");
                          } else {
                            setUploadTab("three");
                          }
                          // setUploadTab("three");
                          setLeftVideo("");
                          setRightVideo("");
                          setUploadDocument("");
                        }}
                      >
                        <img
                          className="large"
                          src="/icons/three.svg"
                          alt="file only"
                        />
                        <span className="sub-title">{intl.formatMessage({ id: 'combined.video' })}</span>
                      </Col>
                      <Col
                        sm={3}
                        md={3}
                        lg={3}
                        // style={{backgroundColor: "#24b2ff"}}
                        className={`top_bar ${
                          uploadTab
                            ? uploadTab == "four"
                              ? "item active"
                              : "item inactive"
                            : "item active"
                        }`}
                        onClick={function () {
                          if (uploadTab == "four") {
                            setUploadTab("");
                          } else {
                            setUploadTab("four");
                          }
                          // setUploadTab("four");
                          setLeftVideo("");
                          setRightVideo("");
                          setUploadDocument("");
                        }}
                      >
                        <img
                          className="large"
                          src="/icons/four.svg"
                          alt="file only"
                        />
                        <span className="sub-title">
                          {intl.formatMessage({ id: 'presentation.file' })}
                        </span>
                      </Col>
                    </div>
                  </div>

                  {uploadTab == "first" ? (
                    videoPagewidth ? (
                      <>
                        <div className="new-video-item form-new-video-item">
                          <div className="col-sm-12 col-md-12 col-lg-12 padding-0 new-video-expand">
                            <div className="no-gutters row ">
                              <div className="col-sm-5 col-md-5 col-lg-5">
                                <div
                                  className="left-box"
                                  style={{ overflow: "hidden" }}
                                >
                                  {leftVideo ? (
                                    // i did modify react player
                                    <ReactPlayer
                                      className="react-player"
                                      url={leftVideo}
                                      width="100%"
                                      // height="24vh"
                                      height="100%"
                                      // width="264px"
                                      controls={true}
                                    />
                                  ) : (
                                    <div>
                                      <div style={{display:'flex',justifyContent:'center'}}>
                                        <img
                                            className=""
                                            src="/icons/Ico-cam.svg"
                                            alt="file only"
                                            width="92"
                                        />
                                        <img
                                            className=""
                                            src="/icons/plus-circle.svg"
                                            alt="file only"
                                            width="35"
                                        />
                                      </div>


                                      <p>
                                        {intl.formatMessage({ id: 'drag.drop.cam' })}{" "}
                                        <span> {intl.formatMessage({ id: 'drag.drop.file.select' })}</span>
                                      </p>
                                      <input

                                        className="file-input"
                                        type="file"
                                        accept="video/*"
                                        onChange={
                                          // videoUpload(event,"left")
                                          function (event: any) {
                                            setLeftVideo(
                                              URL.createObjectURL(
                                                event.target.files[0]
                                              )
                                            );
                                            sLeftVideo(event.target.files[0]);
                                          }
                                        }
                                        hidden={false}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex bottom-left-main">
                                  <div
                                    className="right-box"
                                    style={{ overflow: "hidden" }}
                                  >
                                    {rightVideo ? (
                                      <ReactPlayer
                                        className="react-player"
                                        url={rightVideo}
                                        width="100%"
                                        // height="38vh"
                                        height="100%"
                                        controls={true}
                                      />
                                    ) : (
                                      <div>
                                        <img
                                          className=""
                                          src="/icons/drop-video-right.svg"
                                          alt="file only"
                                          width="85"
                                        />
                                        <p>
                                          {intl.formatMessage({ id: 'drag.drop.video' })}{""}
                                          <span> {intl.formatMessage({ id: 'select.video' })}</span>
                                        </p>
                                        <input
                                          className="file-input"
                                          type="file"
                                          accept="video/*"
                                          onChange={function (event: any) {
                                            setRightVideo(
                                              URL.createObjectURL(
                                                event.target.files[0]
                                              )
                                            );
                                            sRightVideo(event.target.files[0]);
                                          }}
                                          hidden={false}
                                        />
                                      </div>
                                    )}
                                  </div>

                                  <span
                                    className="switch-video"
                                    onClick={function () {
                                      setLeftVideo(rightVideo);
                                      setRightVideo(leftVideo);
                                    }}
                                  >
                                    <img
                                      className=""
                                      src="/icons/switch-video.svg"
                                      alt="file only"
                                      width="15"
                                    />
                                  </span>
                                </div>
                              </div>

                              <div className="col-sm-7 col-md-7 col-lg-7">
                                <div className="left-bottom-box">
                                  {uploadDocument ? (
                                    <>
                                      <img
                                        className="file-icon"
                                        src={"/icons/four.svg"}
                                      />
                                      {/* <p>{fileName}</p> */}
                                      <div
                                        style={{
                                          textAlign: "center",
                                          marginBottom: "10%",
                                        }}
                                      >
                                        <span className="presentation_name_typography">
                                          {fileName}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    // <Document file={uploadDocument}></Document>
                                    <div>
                                      <img
                                        className="drop-icon drop-icon-mob"
                                        src="/icons/drop-file.svg"
                                        alt="file only "
                                        width="25"
                                      />
                                      <p>
                                        {intl.formatMessage({ id: 'drag.drop.file' })}
                                        <span>{intl.formatMessage({ id: 'drag.drop.file.select' })} </span>
                                        {intl.formatMessage({ id: 'optional' })}

                                      </p>
                                      <UploadPresentation
                                        token={token}
                                        presentation_id={p_id}
                                        progress={progress}
                                        setProgress={setProgress}
                                        event_id={eventContext.id}
                                        speaker_id={
                                          userContext.user?.speaker_id
                                        }
                                        onPptStatusChange={(file: string) => {
                                          setFile(file);
                                          setUploadDocument(file);
                                        }}
                                        onFileName={(filename: string) => {
                                          setFileName(filename);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>


                                <div className="save-videos-form d-flex">
                                  <Button
                                    color="primary"
                                    className="cancel btn-cancel"
                                    type="button"
                                    onClick={function () {
                                      if (
                                        leftVideo == "" &&
                                        rightVideo == "" &&
                                        uploadDocument == ""
                                      ) {
                                        setUploadTab("");
                                      } else {
                                        setAlertType("Success");
                                        setPptMessage(
                                          "Are you sure you want to cancel"
                                        );
                                        setShowValidationModal(true);
                                      }
                                    }}
                                  >
                                    Cancel
                                  </Button>

                                  <Button
                                    color="primary"
                                    className="save btn-save"
                                    type="submit"
                                    // **
                                    // * Function to get token for upload video in sprout
                                    // * Note: use only for first time
                                    // * @author   narayan kumar jha
                                    // * @param
                                    // * @return
                                    // */

                                    disabled={disableSaveBtn}
                                    onClick={function () {
                                      if (file === "") {
                                        setAlertType("Error");
                                        setPptMessage("Empty Ppt Not Allowed");
                                        setShowAlertModal(true);
                                      } else {
                                        uploadCall();
                                      }
                                    }}
                                  >
                                    Save
                                  </Button>
                                  {isLoading ? (
                                    <div className="spinner">
                                      <span>Loading...</span>
                                      <div className="half-spinner"></div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {progress ? (
                                    <ProgressBar
                                      now={progress}
                                      variant="primary"
                                    />
                                  ) : (
                                    <div />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="new-video-item form-new-video-item">
                          <div className="col-sm-12 col-md-12 col-lg-12 padding-0 new-video-expand">
                            <div className="no-gutters row ">
                              <div className="col-sm-5 col-md-5 col-lg-5">
                                <div
                                  className="left-box"
                                  style={{ overflow: "hidden" }}
                                >
                                  {leftVideo ? (
                                    // i did modify react player
                                    <ReactPlayer
                                      className="react-player"
                                      url={leftVideo}
                                      width="100%"
                                      // height="24vh"
                                      height="100%"
                                      // width="264px"
                                      controls={true}
                                    />
                                  ) : (
                                    <div>

                                      <div style={{display:'flex',justifyContent:'center'}}>
                                        <img
                                            className=""
                                            src="/icons/Ico-cam.svg"
                                            alt="file only"
                                            width="52"
                                        />
                                        <img
                                            className=""
                                            style={{position:'absolute',right:'72px',top:'-12px'}}
                                            src="/icons/plus-circle.svg"
                                            alt="file only"
                                            width="25"
                                        />
                                      </div>


                                      <p>
                                        {intl.formatMessage({ id: 'drag.drop.cam' })}{" "}
                                        <span> {intl.formatMessage({ id: 'drag.drop.file.select' })}</span>
                                      </p>
                                      <input
                                        className="file-input"
                                        type="file"
                                        accept="video/*"
                                        onChange={
                                          // videoUpload(event,"left")
                                          function (event: any) {
                                            setLeftVideo(
                                              URL.createObjectURL(
                                                event.target.files[0]
                                              )
                                            );
                                            sLeftVideo(event.target.files[0]);
                                          }
                                        }
                                        hidden={false}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex bottom-left-main">
                                  <div className="left-bottom-box">
                                    {uploadDocument ? (
                                      <>
                                        <img
                                          className="file-icon"
                                          src={"/icons/four.svg"}
                                        />
                                        {/* <p>{fileName}</p> */}
                                        <div
                                          style={{
                                            textAlign: "center",
                                            marginBottom: "10%",
                                          }}
                                        >
                                          <span className="presentation_name_typography">
                                            {fileName}
                                          </span>
                                        </div>
                                      </>
                                    ) : (
                                      // <Document file={uploadDocument}></Document>
                                      <div>
                                        <img
                                          className="drop-icon"
                                          src="/icons/drop-file.svg"
                                          alt="file only"
                                          width="25"
                                        />
                                        <p>
                                          {intl.formatMessage({ id: 'drag.drop.file' })}
                                          <span> {intl.formatMessage({ id: 'drag.drop.file.select' })} </span>
                                          {intl.formatMessage({ id: 'optional' })}
                                        </p>
                                        <UploadPresentation
                                          token={token}
                                          presentation_id={p_id}
                                          progress={progress}
                                          setProgress={setProgress}
                                          event_id={eventContext.id}
                                          speaker_id={
                                            userContext.user?.speaker_id
                                          }
                                          onPptStatusChange={(file: string) => {
                                            setFile(file);
                                            setUploadDocument(file);
                                          }}
                                          onFileName={(filename: string) => {
                                            setFileName(filename);
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <span
                                    className="switch-video"
                                    onClick={function () {
                                      setLeftVideo(rightVideo);
                                      setRightVideo(leftVideo);
                                    }}
                                  >
                                    <img
                                      className=""
                                      src="/icons/switch-video.svg"
                                      alt="file only"
                                      width="15"
                                    />
                                  </span>
                                </div>
                              </div>

                              <div className="col-sm-7 col-md-7 col-lg-7">
                                <div
                                  className="right-box"
                                  style={{ overflow: "hidden" }}
                                >
                                  {rightVideo ? (
                                    <ReactPlayer
                                      className="react-player"
                                      url={rightVideo}
                                      width="100%"
                                      // height="38vh"
                                      height="100%"
                                      controls={true}
                                    />
                                  ) : (
                                    <div>
                                      <div style={{display:'flex',justifyContent:'center'}}>
                                        <img
                                            className=""
                                            src="/icons/Ico-laptop.svg"
                                            alt="file only"
                                            width="85"
                                        />
                                        <img
                                            style={{position:'absolute',right:'55px',top:'-8px'}}
                                            className=""
                                            src="/icons/plus-circle.svg"
                                            alt="file only"
                                            width="25"
                                        />
                                      </div>

                                      <p>
                                        {intl.formatMessage({ id: 'drag.drop.video' })}{""}
                                        <span> {intl.formatMessage({ id: 'select.video' })}</span>
                                      </p>
                                      <input
                                        className="file-input"
                                        type="file"
                                        accept="video/*"
                                        onChange={function (event: any) {
                                          setRightVideo(
                                            URL.createObjectURL(
                                              event.target.files[0]
                                            )
                                          );
                                          sRightVideo(event.target.files[0]);
                                        }}
                                        hidden={false}
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="save-videos-form d-flex">
                                  <Button
                                    color="primary"
                                    className="cancel btn-cancel"
                                    type="button"
                                    onClick={function () {
                                      if (
                                        leftVideo == "" &&
                                        rightVideo == "" &&
                                        uploadDocument == ""
                                      ) {
                                        setUploadTab("");

                                      } else {
                                        setAlertType("Success");
                                        setPptMessage(
                                          "Are you sure you want to cancel"
                                        );
                                        setShowValidationModal(true);

                                      }
                                    }}
                                  >
                                    Cancel
                                  </Button>

                                  <Button
                                    color="primary"
                                    className="save btn-save"
                                    type="submit"
                                    // **
                                    // * Function to get token for upload video in sprout
                                    // * Note: use only for first time
                                    // * @author   narayan kumar jha
                                    // * @param
                                    // * @return
                                    // */

                                    disabled={disableSaveBtn}
                                    onClick={function () {
                                      if (file === "") {
                                        setAlertType("Error");
                                        setPptMessage("Empty Ppt Not Allowed");
                                        setShowAlertModal(true);
                                      } else {
                                        uploadCall();
                                      }
                                    }}
                                  >
                                    Save
                                  </Button>
                                  {isLoading ? (
                                    <div className="spinner">
                                      <span>Loading...</span>
                                      <div className="half-spinner"></div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {progress ? (
                                    <ProgressBar
                                      now={progress}
                                      variant="primary"
                                    />
                                  ) : (
                                    <div />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  ) :

                  uploadTab == "two" ? (
                    <div className="new-video-item form-new-video-item tab-2">
                      <div className="col-sm-12 col-md-12 col-lg-12 padding-0 new-video-expand">
                        <div className="no-gutters row ">
                          <div className="col-sm-8 col-md-8 col-lg-8">
                            <div
                              className="left-box"
                              style={{ overflow: "hidden" }}
                            >
                              {leftVideo ? (
                                <ReactPlayer
                                  className="react-player"
                                  url={leftVideo}
                                  width="100%"
                                  height="100%"
                                  // width="444px"
                                  controls={true}
                                />
                              ) : (
                                <div className="two-img-text">
                                  <img
                                      className=""
                                      src="/icons/two.svg"
                                      alt="file only"
                                      width="85"
                                  />

                                  <p>
                                    {intl.formatMessage({ id: 'drag.drop.video' })}{" "}
                                    <span> {intl.formatMessage({ id: 'select.video' })}</span>
                                  </p>
                                  <input
                                    className="file-input"
                                    type="file"
                                    accept="video/*"
                                    onChange={function (event: any) {
                                      setLeftVideo(
                                        URL.createObjectURL(
                                          event.target.files[0]
                                        )
                                      );
                                      sLeftVideo(event.target.files[0]);
                                    }}
                                    hidden={false}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-4 col-md-4 col-lg-4">
                            <div className="left-box">
                              {uploadDocument ? (
                                <div className="left-box-ppt ">
                                  <img
                                    className="ppt_img"
                                    src={"/icons/four.svg"}
                                  />
                                  {/* <p>{fileName}</p> */}
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginBottom: "10%",
                                    }}
                                  >
                                    <span className="presentation_name_typography">
                                      {fileName}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className="three-ppt-mob">
                                  <img
                                    // className=""
                                    className="ppt-img-three"
                                    src="/icons/drop-file.svg"
                                    alt="file only"
                                    width="25"
                                  />
                                  <p className="ppt-typography-three">
                                    {intl.formatMessage({ id: 'drag.drop.file' })}
                                    <span> {intl.formatMessage({ id: 'drag.drop.file.select' })} </span>  {intl.formatMessage({ id: 'optional' })}
                                  </p>

                                  <UploadPresentation
                                    token={token}
                                    presentation_id={p_id}
                                    progress={progress}
                                    setProgress={setProgress}
                                    event_id={eventContext.id}
                                    speaker_id={userContext.user?.speaker_id}
                                    onPptStatusChange={(file: string) => {
                                      setFile(file);
                                      setUploadDocument(file);
                                    }}
                                    onFileName={(filename: string) => {
                                      setFileName(filename);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                            <div className="save-videos-form d-flex">
                              <Button
                                color="primary"
                                className="cancel btn-cancel"
                                type="button"
                                onClick={function () {
                                  if (
                                    leftVideo == "" &&
                                    rightVideo == "" &&
                                    uploadDocument == ""
                                  ) {
                                    setUploadTab("");
                                  } else {
                                    setAlertType("Success");
                                    setPptMessage(
                                      "Are you sure you want to cancel"
                                    );
                                    setShowValidationModal(true);
                                  }
                                }}
                              >
                                Cancel
                              </Button>

                              <Button
                                color="primary"
                                className="save btn-save"
                                type="submit"
                                onClick={function () {
                                  if (file === "") {
                                    setAlertType("Error");
                                    setPptMessage("Empty Ppt Not Allowed");
                                    setShowAlertModal(true);
                                  } else {
                                    uploadSectioTwo();
                                  }
                                }}
                              >
                                Save
                              </Button>
                              {isLoading ? (
                                <div className="spinner">
                                  <span>Loading...</span>
                                  <div className="half-spinner"></div>
                                </div>
                              ) : (
                                <> </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : uploadTab == "three" ? (
                    <div className="new-video-item form-new-video-item tab-2">
                      <div className="col-sm-12 col-md-12 col-lg-12 padding-0 new-video-expand">
                        <div className="no-gutters row ">
                          <div className="col-sm-8 col-md-8 col-lg-8">
                            <div
                              className="left-box"
                              style={{ overflow: "hidden" }}
                            >
                              {leftVideo ? (
                                <ReactPlayer
                                  className="react-player"
                                  url={leftVideo}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                />
                              ) : (
                                <div className="two-img-text">
                                  <img
                                      className=""
                                      src="/icons/three.svg"
                                      alt="file only"
                                      width="85"
                                  />
                                  <p>
                                    {intl.formatMessage({ id: 'drag.drop.video' })}{" "}
                                    <span> {intl.formatMessage({ id: 'select.video' })}</span>
                                  </p>

                                  <input
                                    className="file-input"
                                    type="file"
                                    accept="video/*"
                                    onChange={function (event: any) {
                                      setLeftVideo(
                                        URL.createObjectURL(
                                          event.target.files[0]
                                        )
                                      );
                                      sLeftVideo(event.target.files[0]);
                                    }}
                                    hidden={false}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-4 col-md-4 col-lg-4">

                            <div className="left-box">
                              {uploadDocument ? (
                                <div className="left-box-ppt">
                                  <img
                                    className="ppt_img"
                                    src={"/icons/four.svg"}
                                  />
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginBottom: "10%",
                                    }}
                                  >
                                    <span className="presentation_name_typography">
                                      {fileName}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className="three-ppt-mob">
                                  <img
                                    className="ppt-img-three"
                                    src="/icons/drop-file.svg"
                                    alt="file only"
                                    width="25"
                                  />
                                  <p className="ppt-typography-three">
                                    {intl.formatMessage({ id: 'drag.drop.file' })}
                                    <span> {intl.formatMessage({ id: 'drag.drop.file.select' })} </span>
                                  </p>
                                  <UploadPresentation
                                    token={token}
                                    presentation_id={p_id}
                                    progress={progress}
                                    setProgress={setProgress}
                                    event_id={eventContext.id}
                                    speaker_id={userContext.user?.speaker_id}
                                    onPptStatusChange={(file: string) => {
                                      setFile(file);
                                      setUploadDocument(file);
                                    }}
                                    onFileName={(filename: string) => {
                                      setFileName(filename);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                            <div className="save-videos-form d-flex">
                              <Button
                                color="primary"
                                className="cancel btn-cancel"
                                type="button"
                                onClick={function () {
                                  if (
                                    leftVideo == "" &&
                                    rightVideo == "" &&
                                    uploadDocument == ""
                                  ) {
                                    setUploadTab("");
                                  } else {
                                    setAlertType("Success");
                                    setPptMessage(
                                      "Are you sure you want to cancel"
                                    );
                                    setShowValidationModal(true);

                                  }
                                }}
                              >
                                Cancel
                              </Button>

                              <Button
                                color="primary"
                                className="save btn-save"
                                type="submit"
                                onClick={function () {
                                  // check file is selected
                                  if (file === "") {
                                    setAlertType("Error");
                                    setPptMessage("Empty Ppt Not Allowed");
                                    setShowAlertModal(true);
                                  } else {
                                    // upload function for option two
                                    uploadSectioTwo();
                                  }
                                }}
                              >
                                Save
                              </Button>
                              {/* loading components*/}
                              {isLoading ? (
                                <div className="spinner">
                                  <span>Loading...</span>
                                  <div className="half-spinner"></div>
                                </div>
                              ) : (
                                <> </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : uploadTab == "four" ? (  /* components for option four only can choose files*/
                    <div className="new-video-item form-new-video-item tab-3">
                      <div className="col-sm-12 col-md-12 col-lg-12 padding-0 new-video-expand">
                        <div className="no-gutters row ">
                          <div className="col-sm-8 col-md-8 col-lg-8">
                            <div className="left-box">
                              {uploadDocument ? (
                                <div className="left-box-ppt">
                                  <img
                                    className="ppt_img_four"
                                    src={"/icons/four.svg"}
                                  />
                                  <p>{fileName}</p>
                                </div>
                              ) : (
                                <div>
                                  <img
                                    className="ppt_img_default_four"
                                    src="/icons/drop-file.svg"
                                    alt="file only"
                                    width="25"
                                  />
                                  <p>
                                    {intl.formatMessage({ id: 'drag.drop.file' })}
                                    <span> {intl.formatMessage({ id: 'drag.drop.file.select' })} </span>  {intl.formatMessage({ id: 'optional' })}
                                  </p>

                                  <UploadPresentation
                                    token={token}
                                    presentation_id={p_id}
                                    progress={progress}
                                    setProgress={setProgress}
                                    event_id={eventContext.id}
                                    speaker_id={userContext.user?.speaker_id}
                                    onPptStatusChange={(file: string) => {

                                      setFile(file);
                                      setUploadDocument(file);
                                    }}
                                    onFileName={(filename: string) => {
                                      setFileName(filename);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-4 col-md-4 col-lg-4">
                            <div className="right-box"></div>

                            <div className="save-videos-form d-flex">
                              <Button
                                color="primary"
                                className="cancel btn-cancel"
                                type="button"
                                onClick={function () {
                                  if (
                                    leftVideo == "" &&
                                    rightVideo == "" &&
                                    uploadDocument == ""
                                  ) {
                                    setUploadTab("");
                                  } else {
                                    setAlertType("Success");
                                    setPptMessage(
                                      "Are you sure you want to cancel"
                                    );
                                    setShowValidationModal(true);
                                  }
                                }}
                              >
                                Cancel
                              </Button>

                              <Button
                                color="primary"
                                className="save btn-save"
                                type="submit"
                                onClick={function () {
                                  // check file is uploaded
                                  if (file === "") {
                                    setAlertType("Error");
                                    setPptMessage("Empty Ppt Not Allowed");
                                    setShowAlertModal(true);
                                  } else {
                                    // upload function call
                                    uploadSectionFour();
                                  }
                                }}
                              >

                                Save
                              </Button>
                            </div>
                          </div>
                        </div>
                        {/*Data Loading components*/}
                        {isLoading ? (
                          <div className="spinner">
                            <span>Loading...</span>
                            <div className="half-spinner"></div>
                          </div>
                        ) : (
                          <> </>
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Col>
                <Col className="videos-lists">
                  {/*  iterate versions and load each version components */}
                  {versions?.map((version, idx) => {
                    checkedStatus[idx] = version.online;
                    return (
                      <NewVideoItem
                        version={version}
                        PresentationId={p_id}
                        token={token}
                        idx={idx}
                        onChangeCallBack={onDataChangeCallback}
                        openVideoModal={function (video: any) {
                          setActiveVideo({
                            security_token: video.security_token,
                            id: video.id,
                          });
                          setsShowVideoModal(true);
                        }}
                        deleteVersion={function (version_Id: any) {
                          // delete version function call
                          deleteVersionById(version_Id);
                        }}
                        onStatusChange={() => {
                          // status change callback from version item
                          const updatedCheckedState = checkedState.map(
                            (item, index) => (index === idx ? !item : item)
                          );
                          setCheckedState(updatedCheckedState);

                        }}
                        onVideoPlay={
                          (S_T: string, V_ID: string) => setSecurityToken(S_T)
                        }
                        onActivityChange={(
                          idx: number,
                          open: any,
                          status: any,
                          online: boolean,
                          versionId: string
                        ) => {
                          // setActivity(!activity);
                          // ( status == "failed" || status == "processing")
                          function checkValue(checkedStatus: any) {
                            var status = "ofline";

                            // loop for check version is already online ir not
                            for (var i = 0; i < checkedStatus.length; i++) {
                              var name = checkedStatus[i];
                              // name is true mean version is already online
                              if (name == true) {
                                status = "online";
                                break;
                              }
                            }

                            return status;
                          }
                          if (status == "success") {
                            // update checkedStatus value to true in order to disable to other item online action
                            checkedStatus.fill(true,idx,idx);
                            const status = checkValue(checkedStatus);
                            // block for status offline mode
                            if (status == "ofline") {
                              const updatedCheckedState = checkedStatus.map(
                                (item, index) => (index === idx ? !item : item)
                              );
                              // function call for online update
                              updateOnlineValue(
                                versionId,
                                (online = true),
                                idx
                              );
                            } else if (
                                status == "online" &&
                              checkedStatus[idx] == true   // block for status online mode
                            ) {
                              // filter selected version state value
                              const updatedCheckedState = checkedStatus.map(
                                (item, index) => (index === idx ? !item : item)
                              );
                              // update new checked state
                              setCheckedStatus(updatedCheckedState);
                              versions.map((item, index) => {
                                if (index == idx) {
                                  item.online = false;
                                }
                              });
                              // update state
                              setVersions(versions);
                              // function call for offline update
                              updateOnlineValue(
                                versionId,
                                (online = false),
                                idx
                              );

                            } else { // block for item already activated
                              setAlertType("wait");
                              setPptMessage(
                                // "only one version online at a time"
                                "one version is already online please make it offline"
                              );
                              setShowAlertModal(true);
                            }
                          } else {
                            setAlertType("wait");
                            setPptMessage(
                              "You Have To Wait"
                              // Chaptering is going on , please wait a moment
                            );
                            setShowAlertModal(true);
                          }
                        }}
                        status_p={checkedStatus[idx]}
                        isOpen={checkedState[idx]}
                        locale={locale}
                        setLocale={setLocale}
                      />
                    );
                  })}
                </Col>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/*Alert Model Popup*/}
      <AlertModal
        show={showAlertModal}
        handleClose={handleAlertModal}
        type={alertType}
        progress={processCount}
        message={pptmessage}
      />
      {/*Video Model Popup*/}
      <VideoModal
        show={showVideoModal}
        handleClose={handleVideoClose}
        videoId={activeVideo.id}
        securityToken={activeVideo.security_token}
      />
      {/* Validation message Model Popup*/}
      <ValidationModel
        show={showValidationModal}
        handleClose={handleAlertValidationModal}
        type={alertType}
        message={pptmessage}
        onYesClick={function () {
          // deleteVersion(version.versionId);
          setLeftVideo("");
          setRightVideo("");
          setUploadDocument("");
          deleteS3Object(file);
          setUploadTab("");
        }}
      />
      {/*edit profile model components*/}
      <EditProfileModal
        openProfileModal={openProfileModal}
        setOpenProfileModal={setOpenProfileModal}
      />
    </div>
  );
};

export default NewSchedule;
